/**
 * Central toast helpers – re-export react-hot-toast so all toasts are managed in one place.
 * Success/error toasts for API responses are shown automatically in ApiBase interceptors
 * using the message from response (response.data?.data?.message or response.data?.message).
 *
 * Use this file when you need to show a toast manually (e.g. client-side validation).
 */
import toast from "react-hot-toast";
import { isGlobalApiErrorModalOpen } from "./globalApiErrorModal";

export default toast;

export const showSuccess = (message) => toast.success(message);
export const showError = (message) => {
  if (isGlobalApiErrorModalOpen()) return;
  if (message == null) return;
  const msg = typeof message === "string" ? message.trim() : String(message);
  if (!msg) return;
  toast.error(msg);
};
export const showLoading = (message) => toast.loading(message);
export const dismiss = (id) => toast.dismiss(id);
